import React from 'react';

export interface TimelineDaySegmentProps {
  readonly date: Date;
  readonly dayOfMonth: number;
  readonly monthName: string;
  readonly widthPercent: number;
  readonly isLast: boolean;
  readonly isDark: boolean;
}

const TimelineDaySegmentComponent: React.FC<TimelineDaySegmentProps> = ({
  dayOfMonth,
  monthName,
  widthPercent,
  isLast,
  isDark,
}) => {
  return (
    <div
      className={`relative border-r ${
        isDark ? 'bg-gray-700/30 border-gray-600/50' : 'bg-gray-100/50 border-gray-200'
      }`}
      style={{
        width: `${widthPercent}%`,
        marginRight: isLast ? 0 : '1px',
      }}
    >
      <div
        className={`absolute bottom-1 right-1 text-xs leading-tight ${
          isDark ? 'text-gray-400' : 'text-gray-600'
        }`}
      >
        <div className="text-right">
          <div className="font-medium">{dayOfMonth}</div>
          <div className="text-[10px] uppercase opacity-75">{monthName}</div>
        </div>
      </div>
    </div>
  );
};

export const TimelineDaySegment = React.memo(TimelineDaySegmentComponent);
TimelineDaySegment.displayName = 'TimelineDaySegment';

export default TimelineDaySegment;
